import device, { isUnknownOrNull } from 'common/support/device';
import { getUUID } from 'hooks/uuid';

export const UUID_KEY = 'fms_uuid';

export const getFMSFallbackId = async (): Promise<string | null> => {
  let id;
  const rdid = await device.getRDID();
  const uuid = getUUID(UUID_KEY);

  if (!isUnknownOrNull(rdid)) {
    id = rdid;
  } else {
    id = uuid;
  }

  return id;
};

export const getFMSFallbackParams = async (): Promise<{ imafw__fw_vcid2: string | null }> => {
  return {
    imafw__fw_vcid2: await getFMSFallbackId(),
  };
};
